module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-password"
  }, [(_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().done.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_vm._v("\n      " + _vm._s(_vm.i18n().done.text) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.state != 'done') ? _c('form', {
    staticClass: "mdl-card mdl-shadow--2dp",
    on: {
      "submit": _vm.change
    }
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    class: {
      blurred: _vm.state == 'working'
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "serverError"
  }, [_vm._v(_vm._s(_vm.i18n().errors[_vm.error] || _vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    ref: "oldPassword",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "oldPassword",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "oldPassword"
    }
  }, [_vm._v(_vm._s(_vm.i18n().oldPassword))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    ref: "newPassword1",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword1",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword1"
    }
  }, [_vm._v(_vm._s(_vm.i18n().newPassword))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    ref: "newPassword2",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword2",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v(_vm._s(_vm.i18n().retypePassword))]), _vm._v(" "), (_vm.notMatch) ? _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v(_vm._s(_vm.i18n().notMatch))]) : _vm._e()])]), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n().submit) + "\n      ")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-040ccfbb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emailPassword/ChangePassword.vue
// module id = 429
// module chunks = 0